import { Link } from "react-router-dom";

export interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  readTime: string;
  category: string;
  imageUrl: string;
}

export default function ArticleCard({ slug, title, excerpt, readTime, category, imageUrl }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="group block bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer h-full"
    >
      <div className="aspect-[4/3] overflow-hidden bg-background-100">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] md:text-xs font-medium">
            {category}
          </span>
          <span className="text-[10px] md:text-xs text-foreground-400">{readTime}</span>
        </div>
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
      </div>
    </Link>
  );
}